import React from 'react';
import { useTranslation } from 'react-i18next';
import PackageStructurePackageRow from './PackageStructurePackageRowBeta';

const BILLING_CYCLES = [
    { value: 1, label: '1M' },
    { value: 3, label: '3M' },
    { value: 12, label: '12M' },
];

const PackageStructure = ({ packages = [], expandedPackages, expandedTiers, onTogglePackage, onToggleTier, isVisible, onToggleVisibility, selectedPeriod = 12, onPeriodChange }) => {
    const { t } = useTranslation();

    const toggleButtonText = isVisible ? t('priceSimulation.hidePackageStructure') : t('priceSimulation.showPackageStructure');

    return (
        <div className="package-structure">
            <div className="package-structure-header">
                <div className="package-structure-title">
                    <span className="vismaicon vismaicon-sm vismaicon-box"></span>
                    <h3>{t('priceSimulation.packageStructure')}</h3>
                </div>
                <div className="package-structure-controls">
                    <div className="billing-toggle-group">
                        {BILLING_CYCLES.map((cycle) => (
                            <button
                                key={cycle.value}
                                type="button"
                                className={`mb-0 toggle-btn ${selectedPeriod === cycle.value ? 'toggle-btn--active' : ''}`}
                                onClick={() => onPeriodChange && onPeriodChange(cycle.value)}
                            >
                                {cycle.label}
                            </button>
                        ))}
                    </div>
                    <button type="button" className="mb-0 btn btn-link" onClick={onToggleVisibility}>
                        <span className={`mr-4 expand-chevron ${isVisible ? 'expanded' : ''}`}>
                            <span className="caret caret-lg"></span>
                        </span>
                        {toggleButtonText}
                    </button>
                </div>
            </div>

            {isVisible && (
                <div className="package-structure-content">
                    {packages.length === 0 ? (
                        <div className="empty-state">
                            <p>{t('priceSimulation.noPackagesMatch')}</p>
                        </div>
                    ) : (
                        packages.map((pkg) => (
                            <PackageStructurePackageRow
                                key={pkg.id}
                                package={pkg}
                                isExpanded={expandedPackages[pkg.id] || false}
                                onToggle={() => onTogglePackage(pkg.id)}
                                expandedTiers={expandedTiers}
                                onToggleTier={onToggleTier}
                            />
                        ))
                    )}
                </div>
            )}
        </div>
    );
};

export default PackageStructure;
